import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
export interface LegalModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function LegalModal({
  isOpen,
  onClose,
  title,
  children
}: LegalModalProps) {
  // Handle ESC key to close and body scroll lock
  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    if (isOpen) {
      window.addEventListener('keydown', handleEsc);
      document.body.style.overflow = 'hidden';
    }
    return () => {
      window.removeEventListener('keydown', handleEsc);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);
  return <AnimatePresence data-id="element-119">
      {isOpen && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6" data-id="element-120">
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.3
      }} onClick={onClose} className="absolute inset-0 bg-[#5C4B3A]/60 backdrop-blur-sm" aria-hidden="true" data-id="element-121" />

          {/* Modal Card */}
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        type: 'spring',
        damping: 25,
        stiffness: 300
      }} className="relative w-full max-w-3xl max-h-[90vh] bg-white rounded-2xl md:rounded-3xl shadow-2xl flex flex-col overflow-hidden" role="dialog" aria-modal="true" aria-labelledby="modal-title" data-id="element-122">
            {/* Header */}
            <div className="flex items-center justify-between p-6 md:px-8 md:py-6 border-b border-[#5C4B3A]/10 bg-[#FFF8F0]/50" data-id="element-123">
              <h2 id="modal-title" className="font-heading text-2xl md:text-3xl font-bold text-[#2D6A4F]" data-id="element-124">
                {title}
              </h2>
              <button onClick={onClose} className="p-2 text-[#5C4B3A]/60 hover:text-[#E76F51] hover:bg-[#FFF8F0] rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-[#E76F51]" aria-label="Cerrar modal" data-id="element-125">
                <X size={24} data-id="element-126" />
              </button>
            </div>

            {/* Scrollable Content */}
            <div className="p-6 md:p-8 overflow-y-auto font-body text-[#5C4B3A] space-y-6" data-id="element-127">
              {children}
            </div>

            {/* Footer gradient for scroll indication */}
            <div className="absolute bottom-0 left-0 right-0 h-8 bg-gradient-to-t from-white to-transparent pointer-events-none" data-id="element-128" />
          </motion.div>
        </div>}
    </AnimatePresence>;
}